import { Link } from "react-router-dom";
import { formatDimensions, artworkSrcSet } from "@/data/artworks";

export const ArtworkCard = ({ artwork }) => (
  <article className="group" data-testid={`artwork-card-${artwork.slug}`}>
    <Link to={`/art/${artwork.slug}`} className="block">
      <img
        src={`${artwork.imgBase}-1200.webp`}
        srcSet={artworkSrcSet(artwork)}
        sizes="(max-width: 767px) calc(100vw - 44px), 640px"
        width={artwork.imgWidth}
        height={artwork.imgHeight}
        loading="lazy"
        decoding="async"
        alt={artwork.alt}
        className="block w-full h-auto object-contain transition-opacity duration-500 group-hover:opacity-90"
      />
      <div className="mt-6 md:mt-8">
        <h2
          className="serif text-[#2F2C28]"
          style={{ fontSize: "clamp(1.35rem, 2vw, 2rem)", lineHeight: 1.25 }}
        >
          {artwork.title}
        </h2>
        <div className="mt-2 text-[14px] leading-[1.7] text-[#55524C]">
          {artwork.medium && <p>{artwork.medium}</p>}
          <p>{formatDimensions(artwork)}</p>
        </div>
        <span className="inline-block mt-5 text-[11px] uppercase tracking-[0.24em] text-[#2F2C28] border-b border-[#2F2C28]/40 pb-1 transition-colors group-hover:border-[#2F2C28]">
          View Artwork →
        </span>
      </div>
    </Link>
  </article>
);
